<hum-icon icon="thumb_up" class="icon"></hum-icon>
<div class="text" [ngSwitch]="isLiked">
	<ng-container *ngSwitchDefault>{{ 'like-button.default' | translate }}</ng-container>
	<ng-container *ngSwitchCase="true">{{ 'like-button.liked' | translate }}</ng-container>
</div>
